import { useContext } from 'react';
import { ShellContext } from '@/app/providers/ShellProvider';
import type { ShellContextValue } from '@/app/providers/ShellProvider';

export const useShell = (): ShellContextValue => {
  const context = useContext(ShellContext);
  if (!context) throw new Error('useShell must be used within ShellProvider');
  return context;
};
